import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Globe } from "lucide-react";
import {
  onWebPlatformRequired,
  WEB_PLATFORM_NOTICE_TITLE,
  WEB_PLATFORM_NOTICE_BODY,
  WEB_PLATFORM_NOTICE_ACTION,
} from "../lib/webPlatformLock";

/**
 * Zeigt bei einem global abgefangenen 403 (`web_platform_required`) einen kurzen,
 * freundlichen Upgrade-Hinweis. Spiegelt die Botschaft der vollflächigen
 * `SubscriptionGate`-Sperre: Eine streunende 403 aus einer Hintergrund-Query
 * (aktiver Tarif, aber kein Browser-Zugang) führt so nicht zu einem rohen
 * Fehler, sondern zum selben Hinweis samt Link zur Paketauswahl.
 *
 * Wie die feinkörnige Feature-Sperre wird hier NICHT umgeleitet — der Hinweis
 * erscheint als dezenter Toast, damit eine Hintergrund-Query die aktuelle Seite
 * nicht wegreißt.
 */
export default function WebPlatformLockNotice() {
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const unsubscribe = onWebPlatformRequired(() => {
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 7000);
    });
    return () => {
      unsubscribe();
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="feature-lock-notice" role="status" aria-live="polite">
      <div
        className="feature-lock-notice-card"
        data-testid="notice-web-platform-required"
      >
        <span className="feature-lock-notice-icon">
          <Globe size={18} />
        </span>
        <div className="feature-lock-notice-text">
          <div className="feature-lock-notice-title">
            {WEB_PLATFORM_NOTICE_TITLE}
          </div>
          <div className="feature-lock-notice-sub">
            {WEB_PLATFORM_NOTICE_BODY}
          </div>
          <Link
            to="/pakete"
            className="feature-lock-notice-action"
            onClick={() => setVisible(false)}
          >
            {WEB_PLATFORM_NOTICE_ACTION}
          </Link>
        </div>
      </div>
    </div>
  );
}
